__turbopack_context__.v({
  "app_light_theme": "catalog-module-scss-module__cIrI-W__app_light_theme",
  "appliedFiltersWrap": "catalog-module-scss-module__cIrI-W__appliedFiltersWrap",
  "catalogSeoLinks__collections": "catalog-module-scss-module__cIrI-W__catalogSeoLinks__collections",
  "desktopOnly": "catalog-module-scss-module__cIrI-W__desktopOnly",
  "filterMobile": "catalog-module-scss-module__cIrI-W__filterMobile",
  "hiddenSeoBlocks": "catalog-module-scss-module__cIrI-W__hiddenSeoBlocks",
  "main": "catalog-module-scss-module__cIrI-W__main",
  "mobileAppliedFilters": "catalog-module-scss-module__cIrI-W__mobileAppliedFilters",
  "mobileOnly": "catalog-module-scss-module__cIrI-W__mobileOnly",
  "root": "catalog-module-scss-module__cIrI-W__root",
  "selectorWrap": "catalog-module-scss-module__cIrI-W__selectorWrap",
  "stepFilter": "catalog-module-scss-module__cIrI-W__stepFilter",
});
